var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(new URL(href).pathname).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"16":1,"36":1,"65":1,"126":1,"130":1,"206":1,"443":1,"450":1,"567":1,"832":1,"907":1,"930":1,"938":1,"981":1,"1029":1,"1037":1,"1126":1,"1144":1,"1191":1,"1282":1,"1379":1,"1511":1,"1604":1,"1621":1,"1631":1,"1660":1,"1667":1,"1668":1,"1738":1,"2057":1,"2222":1,"2285":1,"2366":1,"2574":1,"2612":1,"2615":1,"2701":1,"2846":1,"2875":1,"2886":1,"2964":1,"3011":1,"3131":1,"3260":1,"3480":1,"3515":1,"3532":1,"3927":1,"3940":1,"4054":1,"4086":1,"4448":1,"4503":1,"4717":1,"4756":1,"4825":1,"4976":1,"5156":1,"5230":1,"5232":1,"5502":1,"5603":1,"5975":1,"6034":1,"6093":1,"6202":1,"6284":1,"6291":1,"6327":1,"6340":1,"6430":1,"6538":1,"6541":1,"6764":1,"6847":1,"7168":1,"7441":1,"7588":1,"7738":1,"7782":1,"7890":1,"7903":1,"8054":1,"8115":1,"8170":1,"8525":1,"8851":1,"8883":1,"8901":1,"8957":1,"9058":1,"9060":1,"9063":1,"9195":1,"9199":1,"9263":1,"9366":1,"9381":1,"9489":1,"9553":1,"9757":1,"9903":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr